import React from "react";
import { DialogContent } from "@material-ui/core";
import FixedPositionDialog from "../../../../../elements/FixedPositionDialog";
import DialogTitleWithCloseIcon from "../../../../../elements/DialogTitleWithCloseIcon";
import RecipientContainer from "./RecipientContainer";
import I18nText from "../../../../../elements/I18nText";

const RecipientAddressDialog = ({ device, onClose }) => {
  return (
    <>
      <FixedPositionDialog open={true} scroll="body" fullWidth={true}>
        <DialogTitleWithCloseIcon onClose={onClose}>
          <I18nText>devices.settings.billing.sections.recipients</I18nText>
        </DialogTitleWithCloseIcon>
        <DialogContent>
          <RecipientContainer device={device} onClose={onClose} />
        </DialogContent>
      </FixedPositionDialog>
    </>
  );
};

export default RecipientAddressDialog;
